import React, { useState } from "react";
import { t } from "../i18n";
import styles from "./SortBy.module.css";
import { TbFilterCog } from "react-icons/tb";


const Dropdown = ({ options, placeholder, selectedFilter, setSelectedFilter }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const handleOptionSelect = (option) => {
    setSelectedFilter(option);
    setSearchQuery("");
    setIsDropdownOpen(false);
  };
  const handleInputFocus = () => setIsDropdownOpen(true);


  return (
    <div className={styles.dropdown}>
      <input
        type="text"
        value={selectedFilter || searchQuery}
        onChange={handleSearchChange}
        placeholder={placeholder}
        className={styles.searchInput}
        onFocus={handleInputFocus}
        onBlur={() => setTimeout(() => setIsDropdownOpen(false), 150)}
      />
      <div className={`${styles.dropdownContent} ${isDropdownOpen ? styles.show : ""}`}>
        {filteredOptions.map((option) => (
          <div
            key={option}
            className={styles.dropdownItem}
            onClick={() => handleOptionSelect(option)}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};

const SortBy = ({ filter1, setFilter1, filter2, setFilter2, filter3, setFilter3, filter4, setFilter4, clearFilters, isMobile }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeButton, setActiveButton] = useState("All");
  const [showMobileSort, setShowMobileSort] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
    setFilter4(button);
  };

  const handleGoClick = () => {
    setShowMobileSort(false);
  };

  return isMobile ? (
    <>
      {!showMobileSort && (
        <div className={styles.sortBanner}>
          <button className={styles.sortMobileOpen} onClick={() => setShowMobileSort(true)}>
             {t("view_all_filters")}
          </button>
        </div>
      )}
  
      {showMobileSort && (
        <div className={styles.sortMobileOverlay}>
          <button className={styles.exitButton} onClick={() => setShowMobileSort(false)}>✖</button>
  
          <h3>{t("sort_posts_by")}</h3>
          <div className={styles.buttonGroup}>
            {[t("all"), t("friends"), t("favorite_games")].map((btn) => (
              <button
                key={btn}
                className={`${styles.sortBtn} ${activeButton === btn ? styles.activeSort : ""}`}
                onClick={() => handleButtonClick(btn)}
              >
                {btn}
              </button>
            ))}
          </div>
  
          <h3>{t("filter_posts_by_tags")}</h3>

            <div className={styles.dropdownBlock}>
              {openDropdown !== null && (
                <button className={styles.exitButtonDropdown} onClick={() => setOpenDropdown(null)}>
                  ✖
                </button>
              )}

              {openDropdown === null && (
                <div className={styles.buttonGroup}>
                  <button
                    className={styles.sortBtn}
                    onClick={() => setOpenDropdown("postType")}
                  >
                    {filter2 || t("post_type")}
                  </button>
                  <button
                    className={styles.sortBtn}
                    onClick={() => setOpenDropdown("other")}
                  >
                    {filter3 || t("other")}
                  </button>
                </div>
                
              )}




              {openDropdown === "postType" && (
                <Dropdown
                  options={["Post", "Poll", "Question"]}
                  placeholder={t("post_type")}
                  selectedFilter={filter2}
                  setSelectedFilter={(val) => {
                    setFilter2(val);
                    setOpenDropdown(null);
                  }}
                />
              )}

              {openDropdown === "other" && (
                <Dropdown
                  options={[
                    "Looking For Team",
                    "Console",
                    "Keyboard and Mouse",
                    "No Microphone",
                  ]}
                  placeholder={t("other")}
                  selectedFilter={filter3}
                  setSelectedFilter={(val) => {
                    setFilter3(val);
                    setOpenDropdown(null);
                  }}
                />
              )}
            </div>
                    


          <button className={styles.clearButtonMobile} onClick={clearFilters}>
            {t("clear")}
          </button>

          <button className={styles.goButton} onClick={handleGoClick}>
            {t("go")}
          </button>
        </div>
      )}
    </>
  ) : (
    // existing desktop version
    <div className={styles.sortBanner}>
      <div className={styles.controlsContainer}>
        <button
          className={`${styles.filterBtn} ${activeButton === "All" ? styles.activeButton : ""}`}
          onClick={() => handleButtonClick("All")}
        >
          {t("all")}
        </button>
        <button
          className={`${styles.filterBtn} ${activeButton === "Friends" ? styles.activeButton : ""}`}
          onClick={() => handleButtonClick("Friends")}
        >
          {t("friends")}
        </button>
        <button
          className={`${styles.filterBtn} ${activeButton === "Favorite Games" ? styles.activeButton : ""}`}
          onClick={() => handleButtonClick("Favorite Games")}
        >
          {t("favorite_games")}
        </button>
  
        <div className={`${styles.dropdownWrapper} ${dropdownOpen ? styles.dropdownActive : ""}`}>
          <Dropdown
            options={["Post", "Poll", "Question"]}
            placeholder={t("post_type")}
            selectedFilter={filter2}
            setSelectedFilter={setFilter2}
          />
          <Dropdown
            options={["Looking For Team", "Console", "Keyboard and Mouse", "No Microphone"]}
            placeholder={t("other")}
            selectedFilter={filter3}
            setSelectedFilter={setFilter3}
          />
          <button className={styles.clearBtn} onClick={clearFilters}>{t("clear")}</button>
        </div>
  
        <div className={styles.filterIcon} onClick={toggleDropdown}>
          <TbFilterCog />
        </div>
      </div>
    </div>
  );
  



};

export default SortBy;
